import { InlineFileUpload } from '@/shared/components/file-upload/InlineFileUpload';

type AdvisorPhotoFieldProps = {
  value: string;
  error?: string;
  onChange: (value: string) => void;
  onUploadingChange?: (uploading: boolean) => void;
};

/**
 * Admin-side upload for a Financial Partner's photo. One field serves both
 * surfaces: the public profile header and the headshot on search /
 * advisor-selection cards (`users.profile_photo`).
 */
export const AdvisorPhotoField = ({
  value,
  error,
  onChange,
  onUploadingChange,
}: AdvisorPhotoFieldProps) => (
  <div className="mt-4">
    <InlineFileUpload
      label="Profile Photo"
      value={value || undefined}
      onChange={onChange}
      accept="image/*"
      maxSizeMB={5}
      hint="Shown on the advisor's profile and on search result cards. Square image recommended (5MB max)."
      error={error}
      previewClassName="h-32 w-32 rounded-full"
      onUploadingChange={onUploadingChange}
    />
  </div>
);
